import client from '../client';

export type TApiVolumeBand = {
  id: number;
  min_gb: number;
  max_gb: number;
  charge_in_eur: number;
}

const list = (): Promise<Array<TApiVolumeBand>> =>
  client.get('/volume-band/').then(response => response.data);

export {
  list
};
